// import "_archive/components/Common/ReactDropdown.scss"
import { find } from "lodash"
import PropTypes from "prop-types"
import React, { Component } from "react"
import Dropdown from "react-dropdown"

class Select extends Component {
    render() {
        const { value, onChange, options, placeholder } = this.props
        const label = find(options, { value }) || value
        return (
            <Dropdown
                value={label}
                onChange={option => onChange(option.value)}
                options={options}
                placeholder={placeholder}
            />
        )
    }
}

Select.propTypes = {
    value: PropTypes.string,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
}

export default Select



// WEBPACK FOOTER //
// ./src/ui/legacy/Select.js